import { motion } from "framer-motion";
import { useMemo } from "react";

const COLORS = [
  "hsl(var(--secondary))",
  "#f472b6", // pink-400
  "#c084fc", // purple-400
  "#fb923c", // orange-400
  "#fbbf24", // amber-400
];

interface ConfettiProps {
  corner?: "left" | "right";
}

const Confetti = ({ corner = "left" }: ConfettiProps) => {
  const confettiPieces = useMemo(() => {
    const isLeft = corner === "left";
    return Array.from({ length: 25 }, (_, i) => ({
      id: i,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      // Horizontal drift: left corner goes right, right corner goes left
      driftX: isLeft ? 50 + Math.random() * 150 : -(50 + Math.random() * 150),
      // Vertical rise
      riseY: -(200 + Math.random() * 300),
      rotation: Math.random() * 720,
      size: Math.random() * 8 + 4,
      shape: Math.random() > 0.5 ? "square" : "circle",
      delay: Math.random() * 2,
      duration: 2 + Math.random() * 1.5,
    }));
  }, [corner]);

  return (
    <div 
      className="absolute pointer-events-none z-20"
      style={{
        bottom: 0,
        left: corner === "left" ? 0 : "auto",
        right: corner === "right" ? 0 : "auto",
      }}
    >
      {confettiPieces.map((piece) => (
        <motion.div
          key={piece.id}
          className={piece.shape === "circle" ? "rounded-full" : ""}
          style={{
            position: "absolute",
            bottom: 0,
            left: corner === "left" ? 0 : "auto",
            right: corner === "right" ? 0 : "auto",
            width: piece.size,
            height: piece.shape === "square" ? piece.size * 1.5 : piece.size,
            backgroundColor: piece.color,
          }}
          animate={{
            y: [0, piece.riseY],
            x: [0, piece.driftX],
            rotate: [0, piece.rotation],
            opacity: [1, 1, 0.6, 0],
          }}
          transition={{
            duration: piece.duration,
            delay: piece.delay,
            repeat: Infinity,
            repeatDelay: Math.random() * 1.5,
            ease: "easeOut",
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;
